const commonTranslation = {
  hello: "Bonjour",
  welcome: "Bienvenue",
  english: "Anglais",
  german: "Allemand",
  italian: "Italien",
  french: "Français",
  currentLanguage: "fr-FR"
};

const loginComponent = {
  email: "E-Mail",
  emailAddress: "Adresse e-mail",
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  login: "Connexion",
  signUp: "Enregistrer",
  multifactorAuthentication: "Authentification multifacteur",
  OTPCode: "Code OTP",
  verifyAndProceed: "Vérifier & continuer",
  resendOTP: "Renvoyer OTP",
  readMore: "Plus d'informations",
  logout: "Se déconnecter",
  loginOrSignup: "Connexion",
  loginWelcome: "Bienvenue ! Veuillez entrer vos informations.",
  enterEmail: "Entrez votre e-mail",
  enterPassword: "Mot de passe",
  getStarted: "Commencer !",
  profile: "Profil",
  assignment_confirmation: "Confirmation d'attribution",
  revoke_confirmation: "Confirmation de révocation",
  verificationRequired: "Vérification requise",
  verificationDescription: "Entrez le code qui apparaît dans votre application d'authentification",
  no_content: "Pas de contenu",
  loginRemember: "Se souvenir de moi pendant 24 heures",
  ForgotPassword: "Mot de passe oublié",
  NoAccount: "Vous n'avez pas de compte?",
  loginAppInfo: "Je n'ai pas accès à mon application d'authentification",
  loginSuccess: "Connexion réussie",
  loginError: "Erreur de connexion"
};

const dashboardComponent = {
	gridView: "Vue grille",
	tableView: "Vue de tableau",
	PDFExtraction: "Tableau de bord FNOL",
	search: "Recherche",
	filter: "Filtre",
	filters: "Filtres",
	sortBy: "Trier par",
	refresh: "Actualiser",
	sort: "Trier",
	sortFields: "Champs à trier",
	edit: "Modifier",
	download: "Télécharger",
	versionHistory: "Historique",
	documentName: "Nom du document",
	asc: "Ascendant",
	desc: "Descendant",
	operator: "Opérateur",
	receiverName: "Nom du destinataire",
	receiver: "Destinataire",
	extractedAt: "Extrait le",
	lastModified: "Dernière modification",
	noOfPages: "Nombre de pages",
	status: "Statut",
	action: "Fonction",
	details: "Détails",
	generalInformation: "Informations générales",
	medicine_info: "Informations sur les médicaments",
	invoice: "Facture",
	invoiceDate: "Date de la facture",
	invoiceReference: "Référence de facture",
	vetName: "Nom du vétérinaire",
	vetStreet: "Rue vétérinaire",
	city: "Ville",
	postalCode: "Code Postal",
	language: "Langue",
	policyholderName: "Nom du preneur d'assurance",
	policyholderAddress: "Adresse du preneur d'assurance",
	treatment: "Traitement",
	treatmentDate: "Date du traitement",
	diagnosis: "Diagnostic",
	itemName: "Nom de l'article",
	quantity: "Quantité",
	prize: "Prix",
	VAT: "TVA",
	addTreatment: "Ajouter un traitement",
	addItem: "Ajouter un article",
	total: "Total",
	subTotal: "Sous-total",
	calculatedSum: "Total après rabais",
	notes: "Notes",
	page: "Page",
	pages: "Pages",
	min: " min",
	mins: " mins",
	hour: " heure",
	hours: " heures",
	day: " jour",
	days: " jours",
	month: " mois",
	months: " mois",
	ago: "il y a",
	modifiedBy: "Changé par",
	modifiedAt: "Changé le",
	clickASC: "Cliquer pour trier par ordre croissant",
	clickDESC: "Cliquer pour trier par ordre décroissant",
	petName: "Nom de l'animal",
	items: "Articles",
	treatmentName: "Nom du traitement",
	InvoiceTotalSumPriceWithoutVAT: "Montant total de la facture hors TVA",
	InvoiceTotalSumPriceWithVAT: "Montant total de la facture avec TVA",
	CalculatedTotalSum: "Total calculé",
	TotalDiscountAmount: "Montant total de la rabais",
	CalculatedTotalSumAfterDiscount: "Total calculé après rabais",
	recent: "Le plus récent",
	viewHistory: "Voir l'historique",
	remember: "Ne demandez plus aujourd'hui",
	rememberSentance:
		"Aujourd'hui, nous ne vous demanderons plus de code de confirmation sur votre appareil de confiance lorsque vous vous connecterez.",
	Complete_login: "Enregistrement complet",
	date: "Date",
	time: "Temps",
	note: "Note",
	comment: "Remarque",
	revoke: "Révoquer",
	deleteTreatment: "Supprimer le traitement",
	deleteItem: "Supprimer l'article",
	lastUpdate: "Dernière mise à jour",
	board: "Carreaux",
	table: "Tableau",
	modified: "Modifié par",
	showing: "Affichage",
	totalSum: "Montant total",
	of: "de",
	none: "Aucun",
	customVAT: "TVA personnalisée",
	quality_level: "Niveau de Qualité",
	good: "Bon",
	verify: "Vérifier",
	not_extracted: "Non Extrait",
	"Missing Data": "Données manquantes",
	apply: "Appliquer",
	copy: "Copier",
	moveToPage: "Déplacer vers la page",
	clearSelection: "Effacer la sélection",
	pasteItem: "Coller Ici",
};

const commonEvents = {
  add: "Ajouter",
  update: "Mettre à jour",
  save: "Sauvegarder",
  cancel: "Annuler",
  reset: "Réinitialiser",
  download: "Télécharger",
  clear: "Effacer",
  delete: "Supprimer",
  assign: "Attribuer",
  back: "Retour",
  resetInitial: "Réinitialiser au début",
  enter_notes: "Saisissez vos notes ici...",
  Updated: "Mis à jour",
  Exported: "Exporté",
  Revoked: "Révoqué",
  Assigned: "Attribué",
  medicineDescription: "Description médicale",
  purpose: "Objectif",
  usedFor: "Utilisé pour",
  petTypes: "Types d'animaux",
  activeIngredients: "Ingrédients actifs",
  category: "Catégorie",
  typeOfDamage: "Type de dommage",
  causeOfDamage: "Cause du dommage",
  loading: "Chargement..."
};

const documentStatus = {
  not_yet_started: "Pas commencé",
  in_progress: "En cours de traitement",
  completed: "Complété"
};

const confirmationMessage = {
  deleteConfirmationTitle: "Confirmer l'effacement",
  deleteActionTreatmentContent: 
    "Êtes-vous sûr de vouloir supprimer ce traitement ? Cette action ne peut pas être annulée",
  deleteActionItemContent: 
    "Êtes-vous sûr de vouloir supprimer cet article ? Cette action ne peut pas être annulée",
  resetConfirmationTitle: "Confirmer la réinitialisation",
  resetToInitialConfirmationTitle: "Réinitialisation à l'état initial",
  resetActionContent: 
    "Êtes-vous sûr de vouloir effectuer une réinitialisation ? Cette action ne peut pas être annulée",
  resetInitialActionContent: 
    "Êtes-vous sûr de vouloir revenir à l'état initial ? Cette action ne peut pas être annulée",
  assignmentConfirmation: 
    "Êtes-vous sûr de vouloir vous attribuer ce document ?",
  revokeConfirmation: "Êtes-vous sûr(e) de vouloir annuler l'attribution de ce document à vous-même ?",
  reAssignConfirmation: 
    "Êtes-vous sûr de vouloir vous réattribuer ce document ?",
  assignedTo: "Ce document est attribué à"
};

const errorNotification = {
  invalidEmail: "Veuillez saisir une adresse e-mail valide !",
  emailEmpty: "Veuillez saisir votre adresse e-mail !",
  passwordEmpty: "Veuillez saisir votre mot de passe !",
  notAllowedToEdit: "Ce document ne peut pas être modifié",
  noteNotSaved: "Les notes ne sont pas sauvegardées",
  tokenExpired: "Votre session a expiré, veuillez vous reconnecter",
  accessDenied: "Accès refusé",
  notAssigned: "Veuillez attribuer le document à vous-même pour y accéder"
};

const successNotification = {
  DocumentResetToInitial: "Réinitialisation à la version originale réussie",
  UpdateSuccess: "Mis à jour avec succès",
  noteSaved: "Les notes ont été sauvegardées avec succès",
  successDocumentProgressStatus: "Attribution réussie",
  revokeDocument: "Attribution révoquée"
};

export const frJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessage,
  ...successNotification
};
